// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__FPo2_","text":"styles_text__OPWXT","box":"styles_box__lNfoS"};